import { makeAutoObservable } from "mobx";
import { headerService } from "./HeaderService";
import { HttpStatusCode } from "axios";
import { toastUtils } from "../../../common/utils/Toastutils";
import StorageService from "../../../common/service/StorageService";
import {logoutStore} from "../../../pages/user/logout/LogoutStore";
const storageService = new StorageService();
class HeaderStore {
    isLoading: boolean = false;
    timePackageWebsite = "";
    dataDomain:any;
    isMenuMobile: boolean = false;
    async getBanner() {}
    isMenuMobileProduct:boolean = false;
    isMenuMobileQrcode:boolean = false;
    async fetchDomain() {
        if (localStorage.getItem("idDomain")) {
            let params = {
                domain_name: localStorage.getItem("idDomain"),
            };
            this.isLoading = true;
            const result = await headerService.fetchDomain(params);
            if (result.status == HttpStatusCode.Ok) {
                this.isLoading = false;
                if (result.body.remaining_day > 0) {
                    this.dataDomain = result.body;
                    this.timePackageWebsite = `${result.body.remaining_day}`;
                    if(StorageService.getLocalStore('tenant_id') !== result.body.tenant_id){
                        StorageService.setLocalStore('tenant_id',result.body.tenant_id);
                    }
                } else {
                    toastUtils.warning("Gói POS của bạn đã hết hạn!")
                    StorageService.removeToken()
                    StorageService.removeRefreshToken()
                    setTimeout(() => {
                        window.location.href = "/dang-nhap";
                    }, 1500);
                }
            } else {
                toastUtils.error("Đã có lỗi xảy ra", "");
            }
        }
    }
    constructor() {
        makeAutoObservable(this);
    }
}

export const headerStore = new HeaderStore();
